import axios from "axios";
import store from '@store'

export default {

    getEmpresa(params,empresa,callback) {

      var header = { "Content-Type": "application/json" };

      var data = {
            Token: params.Token,
            ClientSecret: empresa.EmpresaClientSecret,
            EmpresaId: empresa.EmpresaId,
            EmpleadoId: empresa.EmpleadoId,
            ClienteId: empresa.ClienteId
      }; 

      
       axios.post("/WebSalesConfiguracion", data, header).then(
          response => {
          if (response.data.Code == 0)  
           {
              var usuario = {
                  EmpresaId: response.data.EmpresaId,
                  EmpresaNombre: response.data.EmpresaNombre,
                  Token: response.data.Token,
                  FechaGeneracion: response.data.FechaGeneracion,
                  FechaVencimiento: response.data.FechaVencimiento,

                  EsEmpleado: empresa.EsEmpleado,
                  EmpleadoId: empresa.EmpleadoId,
                  EmpleadoNombre: empresa.EmpleadoNombre,
                  ClienteId: empresa.ClienteId,
                  ClienteNombre: empresa.ClienteNombre,
                  ClienteListaPrecioId: empresa.ClienteListaPrecioId,
                  ArchivoLogoId: response.data.ArchivoLogoId,
                  ArchivoLogoUrl: response.data.ArchivoLogoUrl,
                  ArchivoCircuitoId: response.data.ArchivoCircuitoId,
                  ArchivoCircuitoUrl: response.data.ArchivoCircuitoUrl,

                  ArchivoFondoId: response.data.ArchivoFondoId,
                  TituloCategoria: response.data.TituloCategoria,
                  TituloSubcategoria: response.data.TituloSubcategoria,
                  ControlaStock: response.data.ControlaStock,
                  ControlaCredito: response.data.ControlaCredito,
                  ClienteAltaHabilitada: response.data.ClienteAltaHabilitada,
                  CobranzasHabilitada: response.data.CobranzasHabilitada,
                  DevolucionesHabilitadas: response.data.DevolucionesHabilitadas,
                  PresupuestosHabilitados: response.data.PresupuestosHabilitados,
                  TipoIngresoCantidad: response.data.TipoIngresoCantidad,
                  HabilitarSeguimiento: response.data.HabilitarSeguimiento,
                  ProductoCategoria: response.data.ProductoCategoria,
                  PermitirClientesAgreguenPromociones: response.data.PermitirClientesAgreguenPromociones,
                  PermiteRetiroDeposito: response.data.PermiteRetiroDeposito,
                  PorcentajeDescuentoMaximoPrecio: response.data.PorcentajeDescuentoMaximoPrecio,
                  IngresaFechaEntrega: response.data.IngresaFechaEntrega,
                  DiasFechaEntrega: response.data.DiasFechaEntrega,
                  DiasEntregaHabiles: response.data.DiasEntregaHabiles,
                  PermiteEnvioPdf: response.data.PermiteEnvioPdf,
                  NroFiscalObligatorio: response.data.NroFiscalObligatorio
                };

                var entorno = {'idEmpresa':empresa.EmpresaId,'clientSecret':empresa.EmpresaClientSecret} 
                store.commit("user/saveUsuario", usuario);
                store.commit('entorno/save',entorno);
                if (callback != null)
                {
                  callback()
                }
              }
            },
            error => {
              console.log(error);
            }
          );

    },


}


// WEBPACK FOOTER //
// ./src/helpers/helper.js